import React from 'react'
import useAuth from "@hooks/useAuth"
import { Redirect, Route, RouteProps } from "react-router-dom"
import { route } from '@helpers'

/**
 * User must miss name and other details to access the route.
 */
export default function withoutDetails() {
    return ({ children, component, ...props }: RouteProps) => {
        const { hasDetails } = useAuth()
        if (hasDetails) return <Redirect to={route("customer")} />
        if (component) return <Route {...props} component={component} />
        return <Route {...props}>{children}</Route>    
    }
}